import { render, staticRenderFns } from "./RepairsDetail.vue?vue&type=template&id=62995f1f"
import script from "./RepairsDetail.vue?vue&type=script&lang=js"
export * from "./RepairsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports